import { render } from "./SendMessagePage.vue?vue&type=template&id=eed6e064&ts=true"
import script from "./SendMessagePage.vue?vue&type=script&lang=ts"
export * from "./SendMessagePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__